import { render, staticRenderFns } from "./ContactBar.vue?vue&type=template&id=6fe2ea61"
import script from "./ContactBar.vue?vue&type=script&lang=ts"
export * from "./ContactBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports